import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { AppConfig } from '~/core/models/appconfig';

@Injectable({
    providedIn: 'root'
})
export class AppConfigService {
    private config: AppConfig;

    constructor() {
        // Load configuration from environment file (compile-time)
        // Angular will swap environment.ts with environment.{env}.ts based on build configuration
        this.config = environment as any;
        console.log('[AppConfigService] Environment Details:', {
            name: environment.name,
            environment: (environment as any).environment,
            production: environment.production,
            apiUrl: (environment as any).apiUrl,
            baseUrl: (environment as any).baseUrl
        });
    }

    public async init(): Promise<boolean> {
        // Configuration is already loaded in constructor
        // This method exists for compatibility with APP_INITIALIZER pattern
        return Promise.resolve(true);
    }

    public getConfig(key?: string | Array<string>): any {
        if (!key || (Array.isArray(key) && !key[0])) {
            return this.config;
        }

        if (!Array.isArray(key)) {
            key = key.split('.');
        }

        return key.reduce((acc: any, current: string) => acc[current], this.config);
    }
}